import { Box, Checkbox, FormControl, FormControlLabel, Typography } from "@mui/material";
import { ITheme } from "../../../utils/theme";
import { availableLabelStyle, shiftCardWrapperStyle } from "../styled";
import { TooltipDecorator } from "./TooltipDecorator";

export interface IShiftCardProps {
  checked: boolean,
  onCheck: (e: React.ChangeEvent<HTMLInputElement>) => void,
  description: string,
  isAvailable: boolean,
  status: string,
  otherTimeNumber: number,
  despatchId: string
}

export const ShiftCard = ({
  checked,
  onCheck,
  description,
  isAvailable,
  status,
  otherTimeNumber,
  despatchId
}: IShiftCardProps) => (
  <Box sx={(theme: ITheme) => shiftCardWrapperStyle(theme, otherTimeNumber)}>
    <TooltipDecorator
      title="If you select SQ Acceptance option for any of the following shifts you WILL be dispatched to a Squamish Job if there is one available."
      showTooltip={otherTimeNumber === 5}
    >
      <FormControl sx={{ display: 'block', pr: { xs: 0, md: 4 } }}>
        <FormControlLabel
          value={despatchId}
          control={<Checkbox checked={checked} onChange={(e) => onCheck(e)} />}
          label={description}
          sx={{ mr: { xs: 0, md: 2 }, '& .MuiFormControlLabel-label': { fontWeight: otherTimeNumber === 0 ? 'bold' : 'initial' } }}
        />
      </FormControl>
    </TooltipDecorator>
    <Typography className={isAvailable ? 'available' : ''} sx={availableLabelStyle}>
      {status}
    </Typography>
  </Box>
)